<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
          <c-select
            type="search"
            :comboItems="documentKindItems"
            itemText="documentKindName"
            itemValue="documentClassCd"
            label="문서분류"
            name="documentClassCd"
            v-model="searchParam.documentClassCd">
          </c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-text
            label="문서명"
            name="documentTitle"
            v-model="searchParam.documentTitle">
          </c-text>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="공정안전자료 문서 목록"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      :selection="popupParam.type"
      rowKey="psiDocumentId"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="선택" icon="check" @btnClicked="select" />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'document-pop',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          type: 'single',
          processCd: '',
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      documentKindItems: [],
      searchParam: {
        plantCd: '',
        processCd: '',
        deptCd: '',
        documentClassCd: null,
        documentTitle: '',
        useFlag: 'Y',
      },
      grid: {
        columns: [
          {
            name: 'documentKindName',
            field: 'documentKindName',
            label: '문서분류',
            align: 'center',
            style: 'width: 300px',
            sortable: false,
          },
          {
            name: 'documentTitle',
            field: 'documentTitle',
            label: '문서명',
            align: 'left',
            sortable: false,
          },
          {
            name: 'revisionNum',
            field: 'revisionNum',
            label: '개정',
            align: 'center',
            style: 'width: 60px',
            sortable: false,
          },
        ],
        height: '650px',
        data: [],
      },
      editable: true,
      listUrl: '',
      kindlistUrl: '',
    };
  },
  computed: {
    processDisabled() {
      return Boolean(this.popupParam.processCd);
    }
  },
  watch: {
    contentHeight() {
      let height = (this.contentHeight - this.$refs['searchbox'].$el.offsetHeight - 50);
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + 'px'
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.listUrl = selectConfig.psi.document.list.url;
      this.kindlistUrl = selectConfig.psi.documentkind.url;
      this.getKind();
      this.getList();
    },
    getKind() {
      this.$http.url = this.kindlistUrl;
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.documentKindItems = _result.data;
      },);
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '문서를 선택하세요.', // 도면을 선택하세요
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
  }
};
</script>
